// Template229: Kuala Lumpur - Transporte (Subway.jsx)
// Header, intro, box Red de metro y trenes (list + sticker + tip Touch 'n Go), Consejos rápidos (list), box Grab.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template229 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const metroTitle = page?.texts?.[2]?.content;
	const metroList = page?.texts?.[3]?.content;
	const tipsTitle = page?.texts?.[4]?.content;
	const tipsList = page?.texts?.[5]?.content;
	const grabText = page?.texts?.[6]?.content;
	const touchTip = page?.texts?.[7]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
		color: "#2e7d5b",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 99999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				</Box>
			)}

			{/* Box Red de metro y trenes */}
			{(metroTitle || metroList) && (
				<Box
					data-block-id="text-2"
					sx={{
						backgroundColor: "#dee7e3",
						border: "2px solid #2E7D5B",
						borderRadius: "12px",
						padding: "16px",
						margin: "0 16px 16px 16px",
						position: "relative",
					}}
				>
					<Box style={{ width: "100%" }}>
						{metroTitle && (
							<Box component="h3" sx={estiloH3}>
								{metroTitle}
							</Box>
						)}
						{metroList && (
							<Box
								component="ul"
								sx={{ paddingLeft: "18px", margin: 0, fontSize: 13 }}
								dangerouslySetInnerHTML={{ __html: metroList }}
							/>
						)}
					</Box>
					{stickerImage && (
						<Box
							component="img"
							src={stickerImage}
							alt=""
							sx={{
								width: 110,
								position: "absolute",
								bottom: isSmallScreen ? -90 : -80,
								right: isSmallScreen ? -12 : -30,
							}}
						/>
					)}
					{touchTip && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -50 : -50,
								right: isSmallScreen ? 80 : 50,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 200,
							}}
							dangerouslySetInnerHTML={{ __html: touchTip }}
						/>
					)}
				</Box>
			)}

			{/* Consejos rápidos */}
			{(tipsTitle || tipsList) && (
				<Box
					data-block-id="text-3"
					sx={{ padding: "0 16px", fontSize: 13, color: "#444", marginTop: 5 }}
				>
					{tipsTitle && (
						<Box component="h3" sx={estiloH3}>
							{tipsTitle}
						</Box>
					)}
					{tipsList && (
						<Box
							component="ul"
							sx={{ paddingLeft: "18px" }}
							dangerouslySetInnerHTML={{ __html: tipsList }}
						/>
					)}
				</Box>
			)}

			{grabText && (
				<Box data-block-id="text-4" sx={{ padding: "0 16px", paddingBottom: isSmallScreen ? 2 : 0 }}>
					<Box
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "10px 12px",
							marginTop: "8px",
							fontSize: 12,
							color: "#444",
						}}
						dangerouslySetInnerHTML={{ __html: grabText }}
					/>
				</Box>
			)}
		</Box>
	);
};

Template229.thumbnail = "/images/template-1.png";
export default Template229;
